import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PaymentService, Receipt } from '../payment.service';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit, OnDestroy {

  @ViewChild('pdfContent') pdfContent: ElementRef;
  receipt: Receipt;
  emailSent: boolean = false;
  fileDownload: boolean = false;
  private readonly destroy$ = new Subject<void>();

  constructor(private route: ActivatedRoute, private payService: PaymentService, private authService: AuthService, private utilService: UtilitieService) {
  }

  async emailReceipt() {
    this.emailSent = true;
    let result: boolean = await this.payService.emailPdf(this.pdfContent);
    if (result) {
      setTimeout(() => {
        this.emailSent = false;
      }, 5000);
    }
  }

  downloadReceipt() {
    this.fileDownload = true;
    this.payService.downLoadReceipt(this.pdfContent);
    setTimeout(() => {
      this.fileDownload = false;
    }, 5000);
  }

  ngOnInit(): void {

    //this.payService.getSubInfo  

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(async params => {
        this.utilService.updateLoading(true);
        let sessionId: string = params['session_id'];
        if (sessionId) {
          this.receipt = await this.payService.getReceipt(sessionId);
          const s = await this.payService.checkForActiveSubscription();
          if (s) {
            this.authService.storeAuthToken(s);
          }
        }
        this.utilService.updateLoading(false);


      });
    this.utilService.updateLoading(false);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
